var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2904_21076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0102 14.4927H47.7918V9.27434C47.7918 7.87934 46.6552 6.74268 45.2602 6.74268H45.1827C43.7618 6.74268 42.6252 7.87934 42.6252 9.27434V14.4927H37.4327C36.0377 14.4927 34.901 15.6293 34.8752 17.0243V17.1018C34.8752 18.5227 36.0118 19.6593 37.4327 19.6593H42.6252V24.8518C42.6252 26.2468 43.7618 27.4093 45.1827 27.3835H45.2602C46.6552 27.3835 47.7918 26.2468 47.7918 24.8518V19.6593H53.0102C54.4052 19.6593 55.5418 18.5227 55.5418 17.1277V17.0243C55.5418 15.6293 54.4052 14.4927 53.0102 14.4927ZM40.0418 24.8518V22.2427H37.4327C36.0635 22.2427 34.7718 21.7002 33.7902 20.7443C32.8343 19.7627 32.2918 18.471 32.2918 17.0243C32.2918 16.0943 32.5502 15.2418 32.9893 14.4927H11.6252C8.7835 14.4927 6.4585 16.8177 6.4585 19.6593V50.6593C6.4585 53.501 8.7835 55.826 11.6252 55.826H42.6252C45.4668 55.826 47.7918 53.501 47.7918 50.6593V29.2693C47.0168 29.7085 46.1385 29.9927 45.1568 29.9927C42.341 29.9668 40.0418 27.6677 40.0418 24.8518ZM14.2085 50.6593H39.9385C41.0235 50.6593 41.6177 49.4193 40.946 48.5668L33.3252 39.0602C32.8085 38.3885 31.801 38.4143 31.2843 39.086L24.5418 48.076L20.4085 41.8502C19.8918 41.1268 18.8327 41.0752 18.2902 41.7985L13.1752 48.5927C12.5293 49.4452 13.1493 50.6593 14.2085 50.6593Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2904_21076)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.28418,
    width: 62,
    height: 62,
    fill: "#CED4DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPicture);
export default __webpack_public_path__ + "static/media/add-picture.78689f72.svg";
export { ForwardRef as ReactComponent };